import {
  createStore,
  compose,
  applyMiddleware
} from "redux"
import thunk from "redux-thunk"
import reducers from "./reducers"
import epicMiddleware from "./epics"
const middlewares = [thunk, epicMiddleware]

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore(reducers, composeEnhancers(
  applyMiddleware(...middlewares)
))

export default store
